<template>
    <div v-if="load" style="overflow-x: auto;position: relative;">
        <div class="item"             v-for="ativo in ativosAguardando" v-bind:key="ativo" @mouseover="hover_ativo(ativo)" :style="{top: ativo.vl_top+'px', left: ativo.vl_left+'px', height: ativo.vl_height+'px', width: ativo.vl_width + 'px', backgroundColor: ativo.nm_cor}" @mousedown="startDrag($event, ativo)" :id="'posicao'+ativo.cd_ativo"><DxTooltip :hide-on-outside-click="true" :target="'#posicao'+ativo.cd_ativo" show-event="mouseenter" hide-event="mouseleave"> <img height="100px" :src="ativo_tooltip.nm_caminho_imagem"/> <br> <b>Localização: </b>{{ ativo_tooltip.nm_posicao_ativo }}<br><b>Ativo: </b>{{ ativo_tooltip.nm_descricao }}<br><b>Capacidade: </b>{{ ativo_tooltip.qt_us }}<br><b>Livres: </b>{{ (ativo_tooltip.qt_us-ativo_tooltip.ocupados) }}<br><b>Ocupados: </b>{{ ativo_tooltip.ocupados }}<br></DxTooltip></div>
        <div class="item posicionado" v-for="ativo in ativosPosicionados" v-bind:key="ativo" @mouseover="hover_ativo(ativo)" :style="{top: ativo.vl_top+'px', left: ativo.vl_left+'px', height: ativo.vl_height+'px', width: ativo.vl_width + 'px', backgroundColor: ativo.nm_cor}" :id="'posicao'+ativo.cd_ativo" @click="clickAtivo(ativo)">    <DxTooltip :hide-on-outside-click="false" :target="'#posicao'+ativo.cd_ativo" show-event="mouseenter" hide-event="mouseleave"> <img height="100px" :src="ativo_tooltip.nm_caminho_imagem"/> <br> <b>Localização: </b>{{ ativo_tooltip.nm_posicao_ativo }}<br><b>Chave: </b>{{ ativo_tooltip.nm_chave }}<br><b>Ativo: </b>{{ ativo_tooltip.nm_descricao }}<br><b>Capacidade: </b>{{ ativo_tooltip.qt_us }}<br><b>Livres: </b>{{ (ativo_tooltip.qt_us-ativo_tooltip.ocupados) }}<br><b>Ocupados: </b>{{ ativo_tooltip.ocupados }}<br></DxTooltip></div>
        <div class="div_pai">
            <div class="planta_sonda">
                <div class="fases_cima_sonda">
                    <div class="portal_fases"/>
                    <div class="portas">
                        <div class="porta"></div>
                        <div class="espaco_porta"></div>
                        <div class="porta"></div>
                    </div>
                    <div class="fase1">
                        <div v-for="coluna_sonda in fases[0].qt_colunas" :key="coluna_sonda" class="coluna_sonda">
                            <div v-for="linha_sonda in fases[0].qt_linhas" :key="linha_sonda" class="linha_sonda">
                                <div class="localizacao_sonda">.</div>
                            </div>
                        </div>
                    </div>
                    <div class="portas">
                        <div class="porta_fase_cima"></div>
                        <div class="espaco_porta_fase"></div>
                        <div class="porta_fase_baixo"></div>
                    </div>
                    <div class="fase2">
                        <div v-for="coluna_sonda in fases[1].qt_colunas" :key="coluna_sonda" class="coluna_sonda">
                            <div v-for="linha_sonda in fases[1].qt_linhas" :key="linha_sonda" class="linha_sonda">
                                <div class="localizacao_sonda">.</div>
                            </div>
                        </div>
                    </div>
                    <div class="portas">
                        <div class="porta_fase_cima"></div>
                        <div class="espaco_porta_fase"></div>
                        <div class="porta_fase_baixo"></div>
                    </div>
                    <div class="fase3">
                        <div v-for="coluna_sonda in fases[2].qt_colunas" :key="coluna_sonda" class="coluna_sonda">
                            <div v-for="linha_sonda in fases[2].qt_linhas" :key="linha_sonda" class="linha_sonda">
                                <div class="localizacao_sonda">.</div>
                            </div>
                        </div>
                    </div>
                    <div class="mdas">
                        <div class="mda1">
                            <div v-for="coluna_sonda in fases[3].qt_colunas" :key="coluna_sonda" class="coluna_sonda">
                                <div v-for="linha_sonda in fases[3].qt_linhas" :key="linha_sonda" class="linha_sonda">
                                    <div class="localizacao_sonda">.</div>
                                </div>
                            </div>
                        </div>
                        <div class="divisao_mda" />
                        <div class="mda2">
                            <div v-for="coluna_sonda in fases[4].qt_colunas" :key="coluna_sonda" class="coluna_sonda">
                                <div v-for="linha_sonda in fases[4].qt_linhas" :key="linha_sonda" class="linha_sonda">
                                    <div class="localizacao_sonda">.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="portas">
                        <div class="porta_mda"></div>
                        <div class="espaco_porta_mda"></div>
                        <div class="porta_mda"></div>
                    </div>
                </div>
                <div class="corredor">
                    <div class="parede_corredor"/>
                    <div class="corredor_meio"/>
                    <div class="parede_corredor"/>
                    <div class="corredor_meio_maior"/>
                    <div class="parede_corredor"/>
                    <div class="corredor_meio" style="width: 498px;"/>
                    <div class="parede_corredor"/>
                </div>
                <div class="fases_baixo">
                    <div class="pop1">
                        <div class="portas_baixo">
                            <div class="parede"/>
                            <div class="porta_pop"/>
                            <div class="parede"/>
                        </div>
                        <div v-for="coluna_sonda in fases[5].qt_colunas" :key="coluna_sonda" class="coluna_sonda">
                            <div v-for="linha_sonda in fases[5].qt_linhas" :key="linha_sonda" class="linha_sonda">
                                <div class="localizacao_sonda">.</div>
                            </div>
                        </div>
                    </div>
                    <div class="sala_entre_pop1eestoque1">
                    </div>
                    <div class="estoque1">
                        <div class="portas_baixo">
                            <div class="porta_estoque"/>
                            <div class="parede"/>
                        </div>
                    </div>
                    <div class="pre_site">
                        <div class="portas_baixo">
                            <div class="parede"/>
                            <div class="porta_pre_site"/>
                            <div class="parede"/>
                        </div>
                    </div>
                    <div class="sala_entre_presiteestoque2">
                        <div class="sala1">
                            <div class="porta_sala1"></div>
                            <div class="parede_sala1"></div>
                            <div class="porta_sala1"></div>
                        </div>
                        <div class="sala2">
                            <div class="porta_sala2"></div>
                            <div class="parede_sala2"></div>
                            <div class="porta_sala2"></div>
                        </div>
                    </div>
                    <div class="estoque2">
                        <div class="portas_baixo">
                            <div class="porta_estoque"/>
                            <div class="parede"/>
                        </div>
                        <div class="coluna_sonda"/>
                    </div>
                    <div class="desembalagem2">
                        <div class="portas_baixo">
                            <div class="parede"/>
                            <div class="porta_estoque"/>
                            <div class="parede"/>
                        </div>
                    </div>
                    <div class="divisoria_desembalagem2">
                        <div class="parede"/>
                        <div class="divisoria"/>
                        <div class="parede"/>
                    </div>
                    <div class="continuacao_desembalagem2">
                        <div class="portas_baixo">
                            <div class="parede"/>
                            <div class="parede"/>
                        </div>
                    </div>
                    <div class="salaentredesembalagem2epop2">
                        <div class="sala">
                            <div class="porta_sala"></div>
                            <div class="parede_sala"></div>
                            <div class="porta_sala"></div>
                        </div>
                    </div>
                    <div class="pop2">
                        <div class="portas_baixo">
                            <div class="parede"/>
                            <div class="porta_pop"/>
                            <div class="parede"/>
                        </div>
                        <div v-for="coluna_sonda in fases[9].qt_colunas" :key="coluna_sonda" class="coluna_sonda">
                            <div v-for="linha_sonda in fases[9].qt_linhas" :key="linha_sonda" class="linha_sonda">
                                <div class="localizacao_sonda">.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dx-card responsive-paddings">
            TOTAL DE EQUIPAMENTOS: {{fase_selecionada_grafico.qt_equipamento}} <br>
            RACKS INSTALADOS: {{ fase_selecionada_grafico.qt_racks }} <br>
            <DxPieChart
              id="pie"
              :data-source="infos_fase"
              type="doughnut"
              palette="Soft Pastel"
              :title="`TOTAL DE U´S: ${fase_selecionada_grafico.qt_total}`"
            >
              <DxSeries
                argument-field="nm"
                value-field="qt"
              >
                <DxLabel
                  :visible="true"
                  :customize-text="({ valueText, percentText }) => `${valueText} (${percentText})`"
                  position="columns"
                >
                  <DxConnector
                    :visible="true"
                    :width="0.5"
                  />
                  <DxFont :size="16"/>
                </DxLabel>
              </DxSeries>
              <DxLegend
                :column-count="4"
                orientation="horizontal"
                item-text-position="right"
                horizontal-alignment="center"
                vertical-alignment="bottom"
              />
              <DxExport :enabled="true"/>
            </DxPieChart>
        </div>
        <DxPopup :visible="show_popup" :shadding="true" height="100%" width="100%" :resize-enabled="false" v-if="show_popup" style="overflow-y: auto;position: relative;">
            <DxToolbarItem widget="dxButton" toolbar="top" location="after" :options="button_cancelar" />
            <div>
                <ativos_info :ativo="ativo_click"/>
            </div>
        </DxPopup>
    </div>
</template>
<script>
import api from '@/api/api'
//import VueResizable from 'vue-resizable'
import { DxTooltip } from 'devextreme-vue/tooltip'
import DxPieChart, {DxSeries,DxLegend,DxLabel,DxConnector,DxFont,DxExport} from 'devextreme-vue/pie-chart';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import ativos_info from './ativo_selecionado_sonda'
//import DxButton from 'devextreme-vue/button'
export default{
    data(){
        return{
            ativos: [],
            fases: [],
            load: false,
            ativo_tooltip: {},
            ativosAguardando: [],
            ativosPosicionados: [],
            fases_select: [],
            fase_selecionada_grafico: [],
            infos_fase: [],
            fase_selecionada: 9999,
            isDragging: false,
            dragOffset: { x: 0, y: 0 }, // Offset para mover o quadrado
            ativo_posic: {},
            show_popup: false,
            button_cancelar: {
                width: 15,
                icon: 'close',
                type: 'danger',
                onClick: () => {
                    this.show_popup = false
                    //document.body.style.zoom = "80%"
                }
            },
            ativo_click: {}
        }
    },
    async created(){
        await this.carrega_dados()
    },
    async mounted(){
        //document.body.style.zoom = "80%"
    },
    beforeUnmount(){
        //document.body.style.zoom = "100%"
    },
    methods:{
        async carrega_dados(){
            this.ativos = await api.get('consulta_ativo', [])
            this.ativos = this.ativos.filter((e)=> e.cd_tipo_item == 1)
            console.log(this.ativos)
            this.fases = await api.get('consulta_fase',[])
            this.ativosAguardando = [this.ativos.filter(ativo => !ativo.vl_left || !ativo.vl_top).length==0?{}:this.ativos.filter(ativo => !ativo.vl_left || !ativo.vl_top)[0]]
            this.ativosPosicionados = this.ativos.filter(ativo => ativo.vl_left && ativo.vl_top)
            this.fases_select = await api.get('consulta_grafico_mapa', [])
            this.fase_selecionada_grafico = this.fases_select.filter((element)=> element.cd_fase == this.fase_selecionada)[0]
            this.infos_fase = [
                {
                    nm: 'U´s Livres',
                    qt: this.fase_selecionada_grafico.qt_livre
                },
                {
                    nm: 'U´s Ocupadas',
                    qt: this.fase_selecionada_grafico.qt_ocupadas
                }
            ]
            this.load = true
        },
        hover_ativo(ativo){
            console.log('hover', ativo)
            this.ativo_tooltip = ativo
        },
        async savePosition(ativo) {
            const json = {
                top: ativo.vl_top,
                left: ativo.vl_left,
                ativo: ativo.cd_ativo
            };
            await api.post('update_localizacao_ativo', json);
            console.log("Posição salva no backend!");
        },
        startDrag(event, ativo) {
            event.preventDefault();
            console.log('EVENTO',event)
            if(event.button == 2){
                //VIRA O ITEM
                
                this.vira_item(ativo)
                return;
            }
            this.isDragging = true;
            this.ativo_posic = ativo;
            // Calcular o deslocamento inicial entre a posição do mouse e a posição do quadrado
            this.dragOffset.x = event.clientX - this.ativo_posic.vl_left;
            this.dragOffset.y = event.clientY - this.ativo_posic.vl_top;
            
            // Adicionar os eventos de movimento e término do arraste
            document.addEventListener('mousemove', this.onDrag);
            document.addEventListener('mouseup', this.stopDrag);
        },
        onDrag(event) {
            if (this.isDragging) {
              // Atualizar a posição do quadrado enquanto o mouse se move
              this.ativo_posic.vl_left = event.clientX - this.dragOffset.x;
              this.ativo_posic.vl_top = event.clientY - this.dragOffset.y;
            }
        },
        stopDrag() {
            this.isDragging = false;
            // Remover os eventos de movimento e término do arraste
            var js = {
                cd_ativo: this.ativo_posic.cd_ativo,
                vl_left: this.ativo_posic.vl_left,
                vl_top: this.ativo_posic.vl_top,
            }
            this.savePosition(js)
            //this.carrega_dados()
            document.removeEventListener('mousemove', this.onDrag);
            document.removeEventListener('mouseup', this.stopDrag);
        },
        clickAtivo(ativo){
            //document.body.style.zoom = "100%"
            this.ativo_click = ativo
            this.show_popup = true
        },
        async vira_item(ativo){
            var old_h = ativo.vl_height
            var old_w = ativo.vl_width
            ativo.vl_height = old_w
            ativo.vl_width = old_h
            await api.get('vira_item', [ativo.vl_width, ativo.vl_height, ativo.cd_ativo])
        }
        
    },
    components:{
        DxTooltip,DxSeries,DxLegend,DxLabel,DxConnector,DxFont,DxExport,DxPieChart,DxPopup,DxToolbarItem, ativos_info//VueResizable,,DxSeries,DxLegend,DxLabel,DxConnector,DxFont,DxExport,DxPieChart//,DxButton
    }
}
</script>
<style>
.ativos_sem_localizacao{
    margin: 10px;
}
.div_pai{
    display: flex;
    margin-top: 25px;
    margin-left: 5px;
}
.portal{
    background-color: green;
    width: 7px;
    height: 20px;
}
.planta_sonda{
    white-space: nowrap;
    border: 5px solid blue;
    background-color: white;
    margin-left: 20px;
    padding-right: 25px;
}
.porta{
    height: 320px;
    width: 5px;
    background-color: blue;
    border-radius: 20px 20px;
    margin-top: -5px
}
.porta_fase_cima{
    height: 355px;
    width: 5px;
    background-color: blue;
    border-radius: 20px 20px;
    margin-top: -5px
}
.porta_fase_baixo{
    height: 338px;
    width: 5px;
    background-color: blue;
    border-radius: 20px 20px;
    margin-top: -5px
}
.espaco_porta_fase{
    height: 50px;
}
.espaco_porta{
    height: 105px;
}
.porta_mda{
    height: 340px;
    width: 5px;
    background-color: blue;
    border-radius: 20px 20px;
    margin-top: -5px
}
.espaco_porta_mda{
    height: 70px;
}

.fases_cima_sonda{
    display: flex;
    margin-left: 0px;
    margin-top: 40px;
    margin-bottom: 40px;
}
.portal_fases{
    margin-top: 500px;
    width: 80px;
    height: 15px;
    border-top: 5px dotted green;
}
.corredor{
    margin-left: 80px;
    display: flex;
}
.parede_corredor{
    height: 20px; /* Altura da linha */
    width: 5px;
    background-color: blue;
    border-radius: 20px 20px 0px 0px;
    margin-top: -15px
}
.corredor_meio{
    height: 5px; /* Altura da linha */
    width: 418px;
    background-color: blue;
}
.corredor_meio_maior{
    height: 5px; /* Altura da linha */
    width: 482px;
    background-color: blue;
}
.fases_baixo{
    display: flex;
    margin-top: 50px;
}
.fase1{
    margin-top: 10px;
    border: 1px solid blue;
    margin-bottom: 16px;
    border-top: 5px solid blue;
    border-bottom: 5px solid blue;
}
.fase2{
    margin-top: 10px;
    border: 1px solid blue;
    margin-bottom: 16px;
    border-top: 5px solid blue;
    border-bottom: 5px solid blue;
}
.fase3{
    margin-top: 10px;
    border: 1px solid blue;
    margin-bottom: 16px;
    border-top: 5px solid blue;
    border-bottom: 5px solid blue;
}
.mdas{
    margin-top: 10px;
}
.divisao_mda{
    height: 61.5px;
    border-right: 5px dotted green;
}
.mda1{
    border: 1px solid blue;
    border-top: 5px solid blue;
}
.mda2{
    border: 1px solid blue;
    border-bottom: 5px solid blue;
}
.linha_sonda{
    text-align: center;
}
.coluna_sonda{
  display: inline-block;
}
.localizacao_sonda{
    margin: 0;
    border: 0.1vh solid #c2c2c2;
    height: 16px;
    width: 16px;
    font-size: 3px;
}
.sala_entre_pop1eestoque1{
    width: 80px;
    border-top: 5px solid blue;
}
.sala_entre_presiteestoque2{
    display: flex;
    .sala1{
        margin-top: 30px;
        display: flex;
        border-right: 5px solid blue;
    }
    .parede_sala1{
        width: 40px;
    }
    .porta_sala1{
        width: 20px;
        height: 5px;
        background-color: blue;
    }
    .sala2{
        margin-left: 20px;
        display: flex;
        border-left: 5px solid blue;
        border-right: 5px solid blue;
    }
    .parede_sala2{
        width: 35px;
    }
    .porta_sala2{
        width: 35px;
        height: 5px;
        background-color: blue;
    }
}
.pop1{
    border-right: 5px solid blue;
    .parede{
        height: 5px;
        background-color: blue;
        width: 63px;
    }
}
.pop2{
    border-right: 5px solid blue;
    .parede{
        height: 5px;
        background-color: blue;
        width: 63px;
    }
}
.portas_baixo{
    display: flex;
}
.portas{
    align-items: end;
    text-align: right;
}
.porta_pop{
    width: 35px;
    border-top: 5px dotted green;
}
.porta_estoque{
    width: 50px;
    border-top: 5px dotted green;

}
.estoque1{
    border-left: 5px solid blue;
    border-right: 5px solid blue;
    .parede{
        height: 5px;
        background-color: blue;
        width: 70px;
    }
}
.estoque2{
    border-right: 5px solid blue;
    .parede{
        height: 5px;
        background-color: blue;
        width: 48px;
    }
}
.desembalagem2{
    .parede{
        height: 5px;
        background-color: blue;
        width: 43.5px;
    }
}
.divisoria_desembalagem2{
    .parede{
        height: 57px;
        width: 5px;
        background-color: blue;
    }
    .divisoria{
        height: 52px
    }
}
.continuacao_desembalagem2{
    width: 180px;
    border-right: 5px solid blue;
    border-top: 5px solid blue;
}
.porta_pre_site{
    width: 43px;
    border-top: 5px dotted green;
}
.pre_site{
    border-right: 5px solid blue;
    .parede{
        height: 5px;
        background-color: blue;
        width: 37px;
    }
}
.salaentredesembalagem2epop2{
    border-right: 5px solid blue;
    .sala{
        display: flex;
        border-left: 5px solid blue;
    }
    .parede_sala{
        width: 25px;
    }
    .porta_sala{
        width: 10px;
        height: 5px;
        background-color: blue;
    }
}

.item{
    border-radius: 0%;
    border: 0.7px solid black;
    position: absolute; /* Necessário para movimentar o quadrado livremente */
    opacity: 0.8;
}
.ativo_pai{
    padding: 20px;
}

.espaco{
    margin-left: 20px;
}

.aba {
    margin-top: 20px;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f9f9f9;
}
.posicionado{
    user-select: none; /* Impede seleção de texto */
    pointer-events: auto; /* Mantém interatividade */
}
</style>